import React from 'react';
import auth from 'works/legacy/lib/auth';
import { useNavigate } from '@common/hooks';
import { Select } from 'antd';
import { AppContent, Gutter } from '@common/components';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { generateGreetings } from 'works/legacy/lib/date-helper';

type MissionControlSectionType = 'staffing' | 'compliance' | 'billing';

export function MissionControlBasePage({
  children,
  section,
}: {
  children: React.ReactNode;
  section: MissionControlSectionType;
}) {
  const navigate = useNavigate();
  const firstName = parseFirstName();
  setBreadcrumbs([
    {
      name: `${generateGreetings()}, ${firstName}.`,
      path: '/works',
      privateInfo: true,
    },
  ]);

  function onSectionChange(value: MissionControlSectionType) {
    navigate(`/works/home/${value}`);
  }

  return (
    <AppContent>
      <div className="mission-control-page">
        <Gutter size="lg" direction="bottom">
          <header>
            <MissionControlSelector
              onChange={onSectionChange}
              defaultSection={section}
            />
          </header>
        </Gutter>

        <main>{children}</main>
      </div>
    </AppContent>
  );
}

function parseFirstName() {
  return auth.name()?.split(' ')[0];
}

function MissionControlSelector({
  onChange,
  defaultSection,
}: {
  onChange: (value: MissionControlSectionType) => void;
  defaultSection: MissionControlSectionType;
}) {
  return (
    <Select
      size="large"
      style={{ width: 250 }}
      defaultValue={defaultSection}
      options={[
        { label: 'Mission Control: Staffing', value: 'staffing' },
        { label: 'Mission Control: Compliance', value: 'compliance' },
        { label: 'Mission Control: Billing', value: 'billing' },
      ]}
      onChange={onChange}
    />
  );
}
